import { render, staticRenderFns } from "./measurement-unit-modal.vue?vue&type=template&id=52fb4172&scoped=true"
import script from "./measurement-unit-modal.vue?vue&type=script&lang=js"
export * from "./measurement-unit-modal.vue?vue&type=script&lang=js"
import style0 from "./measurement-unit-modal.vue?vue&type=style&index=0&id=52fb4172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb4172",
  null
  
)

export default component.exports